
<mat-dialog-content class="notif-wrapper mat-typography" fxFlex fxLayout="column" fxLayoutAlign="center center">
  <mat-icon class="notification-icon " [ngClass]="matIconName" [svgIcon]="matIconName"></mat-icon>
  <h2 class="notification-text">{{notificationText}}</h2>
</mat-dialog-content>
